import React, { useState } from 'react';
 import styled from "styled-components";
// import {css} from "styled-components/macro"; //eslint-disable-line
import backgroundImage2 from 'images/animated/1.webp';
 
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Header, {NavLink, NavLinks, PrimaryLink, LogoLink, NavToggle, DesktopNavLinks} from "../headers/light.js";
// import ResponsiveVideoEmbed from "../../helpers/ResponsiveVideoEmbed.js";
import { Link } from 'react-router-dom';
import tw from 'twin.macro';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
// import Leanda from "images/animated/leanda.jpeg"
 export const StyledButton = tw.button`
  text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-primary-500 hocus:text-primary-500 text-black lg:text-white
  focus:text-black active:text-black focus-visible:text-black
  lg:focus:text-white lg:active:text-white lg:focus-visible:text-white
  focus:outline-none
`;
export const StyledLink = tw(Link)`
  text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
  font-semibold tracking-wide transition duration-300
  pb-1 border-b-2 border-transparent hover:border-primary-500 hocus:text-primary-500 
`;

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }

  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover`}
  background-image: url(${backgroundImage2});
`;

const OpacityOverlay = styled.div`
  ${tw`z-10 absolute inset-0`}
  background: linear-gradient(100deg, rgba(22, 37, 59, 0.85) 0%, rgba(60, 13, 153, 0.55) 55%, rgba(100, 21, 255, 0.15) 100%);
`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const HeroContent = tw.div`pt-12 pb-16 lg:pt-20 lg:pb-20 px-4 flex flex-col items-center lg:items-start`;

const InfoCards = tw.div`w-full grid grid-cols-1 sm:grid-cols-3 gap-4`;
const InfoCard = styled.div`
  ${tw`px-6 py-5 rounded-2xl text-center lg:text-left`}
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(8px);
`;
const InfoLabel = tw.div`text-xs font-semibold tracking-widest uppercase text-primary-100`;
const InfoValue = tw.div`mt-1 text-lg font-bold text-gray-100`;

export default () => {
  const [anchorElTherapie, setAnchorElTherapie] = React.useState(null);
  const [anchorElOnderzoek, setAnchorElOnderzoek] = React.useState(null);
  const navigate = useNavigate();
  
  const useStyles = makeStyles({
    paper: {
      border: '1px solid lightgrey',
    },
    menuItem: {
      borderBottom: '1px solid lightgrey',
    },
  });
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const [activeMenuItem, setActiveMenuItem] = useState(null);


  const handleMenuOpenTherapie = (event) => {
    setAnchorElTherapie(event.currentTarget);
  };
  
  const handleMenuOpenOnderzoek = (event) => {
    setAnchorElOnderzoek(event.currentTarget);
  };
  
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
  
    window.addEventListener('resize', handleResize);
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const [hoveredItem, setHoveredItem] = useState(null); // State for hover effect
  console.log(hoveredItem)
  // In your component
  const classes = useStyles();

  const handleMouseEnter = (index) => {
    setActiveMenuItem(index); // Set active menu item on mouse enter
    setHoveredItem(index); // Set hovered item
  };

  const handleMouseLeave = () => {
    setHoveredItem(null); // Reset hovered item on mouse leave
  };

  const handleCloseTherapie = React.useCallback(() => {
    setAnchorElTherapie(null);
  }, []);

  const handleCloseOnderzoek = React.useCallback(() => {
    setAnchorElOnderzoek(null);
  }, []);
  


  const onderzoekItems = [
    { path: '/onderzoek/adhd', label: 'ADHD' },
    { path: '/onderzoek/autisme', label: 'Autisme' },
    { path: '/onderzoek/tarieven', label: 'Tarieven' },
  ];
  const [isButtonFocused, setIsButtonFocused] = useState(false);

 
  const menuRef = React.useRef(null);
 
    const defaultLinks = [
    <NavLinks key={1}>
      <div>
      <StyledButton
  onClick={handleMenuOpenTherapie}
  onFocus={() => setIsButtonFocused(true)}
  onBlur={() => setIsButtonFocused(false)}
  style={{
    color: isButtonFocused
      ? window.innerWidth < 1024
        ? 'black'
        : 'white'
      : 'text-primary-500'
  }}
>
        Therapie
      </StyledButton>
            <Menu
        id="simple-menu2"
        anchorEl={anchorElTherapie}
        keepMounted
        open={Boolean(anchorElTherapie)}
        onClose={handleCloseTherapie}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{ paper: classes.paper }} // Apply the border to the Paper component
      >
        {[
          { path: '/therapie/cgt', label: 'CGT' },
          { path: '/therapie/emdr-ie', label: 'Traumatherapie' },
          { path: '/therapie/kpsp', label: 'KPSP' },
          { path: '/therapie/schrijftherapie', label: 'Schrijftherapie' },
          { path: '/therapie/tarieven', label: 'Tarieven' },
        ].map((item, index) => (
          <MenuItem
          key={index}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          selected={activeMenuItem === index}
          onClick={() => {
            handleCloseTherapie();
            navigate(item.path);
          }}
        >
            <StyledLink to={item.path}>{item.label}</StyledLink>
          </MenuItem>
        ))}
      </Menu>
    </div>

    <div>
    <StyledButton
  onClick={handleMenuOpenOnderzoek}
  onFocus={() => setIsButtonFocused(true)}
  onBlur={() => setIsButtonFocused(false)}
  style={{
    color: isButtonFocused
      ? window.innerWidth < 1024
        ? 'black'
        : 'white'
      : 'text-primary-500'
  }}
>
          Onderzoek
        </StyledButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorElOnderzoek}
          keepMounted
          open={Boolean(anchorElOnderzoek)}
          onClose={handleCloseOnderzoek}
          elevation={0}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          ref={menuRef}
          onOpen={() => {
            setTimeout(() => {
              menuRef.current.focus();
            }, 0);
          }}
          classes={{ paper: classes.paper }} // Apply the border to the Paper component
        >
          {onderzoekItems.map((item, index) => (
            <MenuItem
              key={index}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              onClick={() => {
                handleCloseOnderzoek();
                navigate(item.path);
              }}
            >
              <StyledLink to={item.path}>{item.label}</StyledLink>
            </MenuItem>
          ))}
        </Menu>
      </div>

      
      <NavLink href="/supervisie">
        Supervisie
      </NavLink>
  
      <NavLink href="/vragen">
        Veel Gestelde Vragen
      </NavLink>
    </NavLinks>,
    <NavLinks key={2}>
      <PrimaryLink href="/contact">
        Maak een afspraak
      </PrimaryLink>
    </NavLinks>
  ];
    return (
        <Container>
            <OpacityOverlay/>
            <HeroContainer>
            {/* <HeroContainer > */}

                <StyledHeader links={defaultLinks}/>
                <HeroContent>
                  <InfoCards>
                    <InfoCard>
                      <InfoLabel>Wachttijd</InfoLabel>
                      <InfoValue>18 weken (aanmeldstop voor 2026)</InfoValue>
                    </InfoCard>
                    <InfoCard>
                      <InfoLabel>Telefoon</InfoLabel>
                      <InfoValue>06-51170658</InfoValue>
                    </InfoCard>
                    <InfoCard>
                      <InfoLabel>Openingstijden</InfoLabel>
                      <InfoValue>di, wo en vr · 09:00–16:30</InfoValue>
                    </InfoCard>
                  </InfoCards>
                </HeroContent>

            </HeroContainer>
        </Container>
    );
};
